import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app_setting_empty from '@devices/settings/device_settings/app_setting_empty.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyBluGw',
	friendly_name: 'Bluetooth Gateway',
	family: 'gateway',
	isPM: false,
	modes: {
		gateway: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				app_setting_empty,
				{
					title: 'settings',
					components: [
						{ title: 'device_name', component: 'device_name_sys' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
